import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const deleteRule=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.DELETE_RULE_START
    })
    const options={
        url:`${api}/rules/${id}`,
        method:'DELETE',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.DELETE_RULE_SUCCESS,
                payload:id
            }))
            .catch(error=>dispatch({
                type:actionTypes.DELETE_RULE_FAIL,
                payload:getMessage(error)
            }))
}